// Modal para registrar ingreso o egreso de caja (usado en Header y en página Movimientos)
import React, { useEffect, useState } from "react";
import api from "../api";
import { imprimirTicketMovimiento } from "../utils/imprimirTicketCaja";
import "./MovementModal.css";

const FORM_INICIAL = { tipo: "ingreso", monto: "", concepto: "" };

export default function MovementModal({ usuario, movimiento = null, onCerrar, onGuardado, cargando: cargandoProp }) {
  const esEdicion = Boolean(movimiento?.id);
  const [form, setForm] = useState(FORM_INICIAL);
  const [enviando, setEnviando] = useState(false);
  const cargando = cargandoProp || enviando;

  useEffect(() => {
    if (!movimiento) {
      setForm(FORM_INICIAL);
      return;
    }

    setForm({
      tipo: movimiento.tipo || "ingreso",
      monto: movimiento.monto != null ? String(movimiento.monto) : "",
      concepto: movimiento.concepto || "",
    });
  }, [movimiento]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const monto = parseFloat(String(form.monto).replace(",", "."));
    if (!monto || monto <= 0) {
      alert("Ingresa un monto válido mayor a 0.");
      return;
    }
    setEnviando(true);
    const payload = {
      tipo: form.tipo,
      monto,
      concepto: (form.concepto || "").trim() || null,
    };
    const request = esEdicion
      ? api.put(`/api/caja/movimientos/${movimiento.id}`, payload)
      : api.post("/api/caja/movimientos", { ...payload, usuario_id: usuario.id });

    request
      .then(({ data }) => {
        const concepto = (form.concepto || "").trim() || "";
        if (!esEdicion) {
          imprimirTicketMovimiento({
            nombreCajero: usuario?.nombre ?? "",
            tipo: form.tipo,
            monto,
            concepto,
            fecha: new Date(),
          });
          setForm(FORM_INICIAL);
        }
        onGuardado?.(data?.movimiento || null);
        onCerrar();
        alert(esEdicion ? "Movimiento actualizado correctamente." : "Movimiento registrado correctamente.");
      })
      .catch((e) => alert(e?.response?.data?.error || "Error al guardar movimiento"))
      .finally(() => setEnviando(false));
  };

  return (
    <div className="mov-modal-overlay" onClick={() => !cargando && onCerrar()}>
      <div className="mov-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mov-modal-head">
          <h3>{esEdicion ? "Editar movimiento" : "Movimiento de caja"}</h3>
          <button type="button" className="mov-modal-close" onClick={onCerrar} disabled={cargando} aria-label="Cerrar">
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit} className="mov-form">
          <label>
            Tipo
            <select value={form.tipo} onChange={(e) => setForm((f) => ({ ...f, tipo: e.target.value }))}>
              <option value="ingreso">Ingreso</option>
              <option value="egreso">Egreso</option>
            </select>
          </label>
          <label>
            Monto ($)
            <input
              type="number"
              min="1"
              step="0.01"
              value={form.monto}
              onChange={(e) => setForm((f) => ({ ...f, monto: e.target.value }))}
              required
            />
          </label>
          <label>
            Concepto (opcional)
            <input
              type="text"
              value={form.concepto}
              onChange={(e) => setForm((f) => ({ ...f, concepto: e.target.value }))}
              placeholder="Ej: Compra insumos, retiro de caja, ingreso extra"
            />
          </label>
          <div className="mov-modal-actions">
            <button type="button" onClick={onCerrar} disabled={cargando}>Cancelar</button>
            <button type="submit" className="primary" disabled={cargando}>
              {cargando ? "Guardando..." : esEdicion ? "Actualizar" : "Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
